import "./Body.css";
import { Link } from "react-router-dom";
import React from "react";



function PageNotFound(props) {

  return (
    <div className="blog">
        <Link className="link" to="/" >
                <p className="backButton"> back to home </p>
        </Link>
      <h1 className="pageNotFoundText"> page not found! </h1>
    </div>
  );
}

export default PageNotFound;
